import { PanelbarStructure } from "./isPanelbarDetails.js";
import React from "react";

export default class PanelBar extends React.Component<{
    headerText: string;
    children?: React.ReactNode;
    iconName?: string;
    onExpand?: (e) => void;
}, any>{
    private _rootDiv: HTMLDivElement;

    constructor(props) {
        super(props);
    }

    componentDidMount() {
        $(this._rootDiv).children().kendoPanelBar({
            expand: (e) => {
                if (this.props.onExpand)
                    this.props.onExpand(e);
            },
            collapse: (e) => {
                $(e.item).children().removeClass('k-state-selected');
            }
        }).data("kendoPanelBar");
    }

    render() {
        return <div ref={(e) => { this._rootDiv = e }}>
            <PanelbarStructure label={this.props.headerText} keyPropValue="d" iconName={this.props.iconName ?? "info"}>
                <pre>{this.props.children}</pre>
            </PanelbarStructure>
        </div>
    }
}